export const APP_CONFIG = {
  name: import.meta.env.VITE_APP_NAME || "SPICEFront",
  version: import.meta.env.VITE_APP_VERSION || "1.0.0",
  apiUrl: import.meta.env.VITE_API_URL || "http://localhost:3000",
  environment: import.meta.env.MODE,
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
} as const;

export const API_ENDPOINTS = {
  USERS: "/api/users",
  AUTH: "/api/auth",
  SETTINGS: "/api/settings",
  RESTAURANTS: "/api/restaurant/v1",
  ADMIN: "/api/admin/v1",
  MEDIA: "/api/media/v1",
  RESTAURANT_BANCH: "/api/restaurant/v1/branches",
  RESTAURANT_BRANDS: "/api/restaurant/v1/brands",
  RESTAURANT_GROUPS: "/api/restaurant/v1/groups",
} as const;

export const TOLGEE_CONFIG = {
  BASE_URL: import.meta.env.VITE_TOLGEE_BASE_URL || "https://app.tolgee.io",
  PROJECT_ID: import.meta.env.VITE_TOLGEE_PROJECT_ID,
};
